/* Setting Vuex State Management
import { stateSetting, gettersSetting, mutationsSetting, actionsSetting} from './setting'
*/
import axios from '@axios';

const stateSetting = {
  Settings: [],
  SettingsTotal: 0,
  Setting: {}
}

const gettersSetting = {
};

const mutationsSetting = {
  SETTING_LIST_SET(state, value) {
    state.Settings = value.items;
    state.SettingsTotal = value.total;
  },
  SETTING_ITEM_SET(state, value) {
    state.Setting = value;
  }
};

const actionsSetting = {
    fetchSettings(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .post(`${ctx.rootState.apiUrl}/api/settings`, queryParams)
          .then(response => {
            const { items, total } = response.data;
            ctx.commit('SETTING_LIST_SET', {
              items: items,
              total: total
            });
            resolve(response)
          })
          .catch(error => reject(error))
      })
    },
    fetchSetting(ctx, { id }) {
        return new Promise((resolve, reject) => {
            axios
            .get(`${ctx.rootState.apiUrl}/api/settings/${id}`)
            .then(response => {
              ctx.commit('SETTING_ITEM_SET', response.data);
              resolve(response)
            })
            .catch(error => reject(error))
        })
    },
    updateSetting(ctx, { id, entity }) {

      ctx.commit('SETTING_ITEM_SET', entity);  // update immediately
      return new Promise((resolve, reject) => {
        axios
        .put(`${ctx.rootState.apiUrl}/api/settings/${id}`, entity)
        .then(response => {
          ctx.commit('SETTING_ITEM_SET', response.data); // allow for server-side data
          ctx.commit('SNACKBAR_ADD', { color: "secondary", message: " Saved." });
          resolve(response)
        })
        .catch(error => {
          if (error.response && error.response.data) return reject(error.response.data);
          return reject(error);
        })
      })
    },
    createSetting(ctx, { entity }) {

      ctx.commit('SETTING_ITEM_SET', entity);  // update immediately
      return new Promise((resolve, reject) => {
        axios
        .post(`${ctx.rootState.apiUrl}/api/settings/create`, entity)
        .then(response => {
          ctx.commit('SETTING_ITEM_SET', response.data); // allow for server-side data
          resolve(response)
        })
        .catch(error => {
          if (error.response && error.response.data) return reject(error.response.data);
          return reject(error);
        })
      })
    },
    fetchVolumetricSettings(ctx) {
      return new Promise((resolve, reject) => {
        axios
          .get(`${ctx.rootState.apiUrl}/api/settings/volumetric`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updateVolumetricSettings(ctx, request) {
      return new Promise((resolve, reject) => {
        axios
          .post(`${ctx.rootState.apiUrl}/api/settings/volumetric`, request)
          .then(response => {
            ctx.commit('SNACKBAR_ADD', { color: "secondary", message: "Volumetric pricing saved." });
            resolve(response)
          })
          .catch(error => {
            if (error.response && error.response.data) return reject(error.response.data);
            return reject(error);
          })
      })
    },
    fetchSettingsLookup(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        if (queryParams.id) {
          axios
            .get(`${ctx.rootState.apiUrl}/api/settings/${queryParams.id}`)
            .then(response => {
              resolve(response.data)
            })
            .catch(error => reject(error));
        } else {
          axios
            .post(`${ctx.rootState.apiUrl}/api/settings`, queryParams)
            .then(response => {
              resolve(response.data.items);
            })
            .catch(error => reject(error));
        }
      });
    },
}

export {
  stateSetting,
  gettersSetting,
  mutationsSetting,
  actionsSetting
}